import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_CUSTOMER_BILLS,
    FAILURE_CUSTOMER_BILLS_INFO,
    FAILURE_CUSTOMER_COMMISSION_BILLS,
    FAILURE_CUSTOMER_COMMISSION_BILLS_INFO,
    FAILURE_CUSTOMER_DOWNLOADS,
    FAILURE_CUSTOMER_DOWNLOAD_TOPICS,
    REQUEST_CUSTOMER_BILLS,
    REQUEST_CUSTOMER_BILLS_INFO,
    REQUEST_CUSTOMER_COMMISSION_BILLS,
    REQUEST_CUSTOMER_COMMISSION_BILLS_INFO,
    REQUEST_CUSTOMER_DOWNLOADS,
    REQUEST_CUSTOMER_DOWNLOAD_TOPICS,
    SUCCESS_CUSTOMER_BILLS,
    SUCCESS_CUSTOMER_BILLS_INFO,
    SUCCESS_CUSTOMER_COMMISSION_BILLS,
    SUCCESS_CUSTOMER_COMMISSION_BILLS_INFO,
    SUCCESS_CUSTOMER_DOWNLOADS,
    SUCCESS_CUSTOMER_DOWNLOAD_TOPICS,
} from './actions';

/* Customer Download Topics */
export function customerDownloadTopicsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_DOWNLOAD_TOPICS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_DOWNLOAD_TOPICS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_DOWNLOAD_TOPICS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Downloads */
export function customerDownloadsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_DOWNLOADS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_DOWNLOADS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_DOWNLOADS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Bills Info */
export function customerBillsInfoReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_BILLS_INFO:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_BILLS_INFO: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_BILLS_INFO:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Bills */
export function customerBillsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_CUSTOMER_BILLS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_BILLS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_BILLS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Commission Bills Info */
export function customerCommissionBillsInfoReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_COMMISSION_BILLS_INFO:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_COMMISSION_BILLS_INFO: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_COMMISSION_BILLS_INFO:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Commission Bills */
export function customerCommissionBillsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_COMMISSION_BILLS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_COMMISSION_BILLS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_COMMISSION_BILLS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
